'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utilsStyleSvg = require('./utils/styleSvg');

var _utilsStyleSvg2 = _interopRequireDefault(_utilsStyleSvg);

var _reactSvgMorph = require('react-svg-morph');

var _reactIconsLibMd = require('react-icons/lib/md');

var md = _interopRequireWildcard(_reactIconsLibMd);

var iconCounter = 0;

var App = (function (_React$Component) {
	_inherits(App, _React$Component);

	function App(props) {
		_classCallCheck(this, App);

		_get(Object.getPrototypeOf(App.prototype), 'constructor', this).call(this, props);
		this.increment = 0;
		this.swap();
	}

	_createClass(App, [{
		key: 'swap',
		value: function swap() {
			var _this = this;

			setInterval(function () {
				_this.increment++;
				_this.forceUpdate();
			}, 1500);
		}
	}, {
		key: 'render',
		value: function render() {
			var props = this.props;
			var style = {};

			//size
			if (!!props.height) style.height = props.height;
			if (!!props.width) style.width = props.width;
			if (!!props.minWidth) style.minWidth = props.minWidth;
			if (!!props.minHeight) style.minHeight = props.minHeight;

			var fromIcon = md[props.from];
			var toIcon = md[props.to];

			if (fromIcon === undefined || toIcon === undefined) return _react2['default'].DOM.span(null, 'Icon ' + props.icon + ' is not register among icons.');

			var keyFrom = props.from + iconCounter++;
			var keyTo = props.to + iconCounter++;

			var fromIconProps = (0, _utilsStyleSvg2['default'])({ key: keyFrom }, props);
			var toIconProps = (0, _utilsStyleSvg2['default'])({ key: keyTo }, props);

			var icon = this.increment % 2 === 1 ? _react2['default'].createElement(fromIcon, fromIconProps, null) : _react2['default'].createElement(toIcon, toIconProps, null);
			return _react2['default'].createElement(
				_reactSvgMorph.MorphReplace,
				{ duration: props.duration, width: props.width, height: props.height },
				icon
			);
		}
	}]);

	return App;
})(_react2['default'].Component);

exports['default'] = App;
;
App.defaultProps = { from: 'Md3dRotation', to: 'MdAcUnit', minWidth: 100, minHeight: 100 };
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/IconMorphTransition.js
 ** module id = 2220
 ** module chunks = 0
 **/